import { MetrikaContent, MetrikaInfoPanel } from '@metrika/ui-kit';

export const RiskError = () => {
   return (
      <MetrikaContent>
         <MetrikaInfoPanel kind={'error'}>
            <span>Access Denied</span>: You do not have permission to access the platform. Please contact your
            administrator or Metrika for assistance.
         </MetrikaInfoPanel>
      </MetrikaContent>
   );
};
